var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QStepper',_vm._g(_vm._b({class:[
    'SAI-stepper bg-transparent q-pa-none',
    _vm.vertical ? 'SAI-stepper--vertical' : 'SAI-stepper--horizontal'
  ],attrs:{"value":_vm.value,"steps":_vm.steps,"flat":_vm.flat,"vertical":""}},'QStepper',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.displaySteps),function(step,index){return _c('QStep',_vm._b({key:index,class:{
      'SAI-step--historic': step.historic,
      'SAI-step--historic-right-normal': _vm.historicThenNormal(index)
    },attrs:{"color":step.historic ? 'primary-semi-dark' : 'primary-semi-light',"done-color":step.historic ? 'primary-semi-dark' : 'white',"active-color":step.historic ? 'primary-semi-dark' : 'white',"done":step.done || step.historic,"active-icon":step.done ? 'eva-checkmark' : step.icon}},'QStep',step,false),[_vm._t(step.slotName)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }